import { SET_COMPANY } from "../actions/types";

const initialState = {
  company: {}
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY:
      return {
        company: action.payload
      };
    default:
      return state;
  }
};

export default companyReducer;
